export default __webpack_public_path__ + "static/media/14.03bbbc2c.JPG";